import React, { FormEvent, useEffect, useState } from 'react'
import { Form } from 'react-router-dom';
import { Alert, Button, IconButton, InputLabel, TextField } from '@mui/material';

import { IVendorContact } from '../../types/vendor';

import { VendorService } from '../../services/vendorService';

import '../../styles/vendorContactForm.scss';
import { AppConfig } from '../../config/appConfig';

export interface IVendorContactForm {
	id: string;
	contact: IVendorContact;
}

const VendorContactForm: React.FunctionComponent<IVendorContactForm> = ({ id, contact }) => {
	const [formFields, setFormFields] = useState<IVendorContact>(contact);
	const [isSaving, setIsSaving] = useState(false);
	const [errorMessage, setErrorMessage] = useState<string | undefined>();
	const [successMessage, setSuccessMessage] = useState<string | undefined>();

	useEffect(() => {
		setFormFields(contact);
	}, [contact])

	const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		clearSaveResult();
		setIsSaving(true);

		VendorService.setContact(id, formFields)
			.then((response) => {
				console.log('VendorService.setContact: SUCCESS', response)
				setSuccessMessage("Vendor contact information has been saved.");
				setTimeout(() => {
					setSuccessMessage(undefined);					
				}, AppConfig.editSuccessToastMs);
			})
			.catch((error) => {
				console.log('VendorService.setContact: ERROR', error)
				setErrorMessage("We encountered an error while processing your request. Please try again.");
			})
			.finally(() => {
				setIsSaving(false);
				window.scrollTo(0, 0);
			});
	}

	const clearSaveResult = () => {
		setErrorMessage(undefined);
		setSuccessMessage(undefined);
	};

	return (
		<section className="hwi-vendor-contact-form">
			{successMessage &&
				<Alert className="alert-success"
					severity="success"
					action={<IconButton onClick={() => { setSuccessMessage(undefined); }} size='small'>X</IconButton>}>
					{successMessage}
				</Alert>
			}
			{errorMessage &&
				<Alert className="alert-error"
					severity="error"
					action={<IconButton onClick={() => { setErrorMessage(undefined); }} size='small'>X</IconButton>}>
					{errorMessage}
				</Alert>
			}
			<Form onSubmit={(event) => handleSubmit(event)}>
				<div className="row">
					<InputLabel>First Name</InputLabel>
					<TextField className="first-name-field" name="firstName" value={formFields.firstName} size="small" onChange={(event) => { setFormFields({ ...formFields, ["firstName"]: event.target.value }) }}></TextField>
				</div>
				<div className="row">
					<InputLabel>Last Name</InputLabel>
					<TextField className="last-name-field" name="lastName" value={formFields.lastName} size="small" onChange={(event) => { setFormFields({ ...formFields, ["lastName"]: event.target.value }) }}></TextField>
				</div>
				<div className="row">
					<InputLabel>Title</InputLabel>
					<TextField className="title-field" name="title" value={formFields.title} size="small" onChange={(event) => { setFormFields({ ...formFields, ["title"]: event.target.value }) }}></TextField>
				</div>
				<div className="row">
					<InputLabel>Phone</InputLabel>
					<TextField className="phone-field" name="phone" value={formFields.phone} size="small" onChange={(event) => { setFormFields({ ...formFields, ["phone"]: event.target.value }) }}></TextField>
				</div>
				<div className="row">
					<InputLabel>Fax</InputLabel>
					<TextField className="fax-field" name="fax" value={formFields.fax} size="small" onChange={(event) => { setFormFields({ ...formFields, ["fax"]: event.target.value }) }}></TextField>
				</div>
				<div className="row">
					<InputLabel>Email *</InputLabel>
					<TextField className="email-field" required name="email" value={formFields.email} size="small" onChange={(event) => { setFormFields({ ...formFields, ["email"]: event.target.value }) }}></TextField>
				</div>
				<div className="row">
					<InputLabel>Email 2</InputLabel>
					<TextField className="email-field" name="email2" value={formFields.email2} size="small" onChange={(event) => { setFormFields({ ...formFields, ["email2"]: event.target.value }) }}></TextField>
				</div>				
				<div className="row">
					<InputLabel>Email 3</InputLabel>
					<TextField className="email-field" name="email3" value={formFields.email3} size="small" onChange={(event) => { setFormFields({ ...formFields, ["email3"]: event.target.value }) }}></TextField>
				</div>
				<div className="row">
					<InputLabel>Email 4</InputLabel>
					<TextField className="email-field" name="email4" value={formFields.email4} size="small" onChange={(event) => { setFormFields({ ...formFields, ["email4"]: event.target.value }) }}></TextField>
				</div>
				<div className="row">
					<InputLabel>Notes</InputLabel>
					<TextField className="notes-field" name="notes" value={formFields.notes} size="small" multiline={true} rows={3} onChange={(event) => { setFormFields({ ...formFields, ["notes"]: event.target.value }) }}></TextField>
				</div>
				<div className="row controls">
					<Button type="submit" className="save-button" disabled={isSaving} variant="contained">{isSaving ? "Saving..." : "Save Contact"}</Button>
				</div>
			</Form>
		</section >
	)
}

export default VendorContactForm;